/**
 * Standard page header with optional label, title, and action button.
 * Composable building block for derivative app pages.
 */
import type { ReactNode } from 'react'

export type PageHeaderProps = {
  /** Optional label above the title */
  label?: string
  /** Main title */
  title: string
  /** Optional subtitle or description */
  subtitle?: string
  /** Optional action (e.g. button) on the right */
  action?: ReactNode
  /** Additional class name */
  className?: string
}

export function PageHeader({ label, title, subtitle, action, className }: PageHeaderProps) {
  return (
    <div className={className}>
      {label != null && (
        <p className="text-sm font-medium text-foreground-muted mb-1">{label}</p>
      )}
      <div className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-foreground-default">{title}</h1>
          {subtitle != null && (
            <p className="text-foreground-muted mt-1">{subtitle}</p>
          )}
        </div>
        {action != null && <div className="flex-shrink-0">{action}</div>}
      </div>
    </div>
  )
}
